import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Users, Settings } from 'lucide-react';
import ThemeToggle from '../shared/ThemeToggle';
import LanguageSelector from '../shared/LanguageSelector';
import UserBadge from '../shared/UserBadge';

const navItems = [
  { to: '/', icon: Home, labelKey: 'home' as const, end: true },
  { to: '/friends', icon: Users, labelKey: 'friends' as const, end: false },
  { to: '/settings', icon: Settings, labelKey: 'settings' as const, end: false },
] as const;

const activeLinkClass =
  'text-green-600 dark:text-green-400 border-b-2 border-green-500';
const inactiveLinkClass =
  'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 border-b-2 border-transparent';

export default function TopNav() {
  const { t } = useTranslation();

  return (
    <nav
      className="hidden md:block sticky top-0 z-40 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-b border-gray-200 dark:border-gray-700"
      aria-label={t('mainNavigation')}
    >
      <div className="max-w-5xl mx-auto h-14 flex items-center justify-between px-4">
        {/* Left: Logo + app name */}
        <NavLink to="/" className="flex items-center gap-2 shrink-0">
          <img
            src="/icons/icon-120.png"
            alt="Shopman"
            className="w-8 h-8 rounded-lg"
            loading="lazy"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <span className="text-lg font-bold text-gray-800 dark:text-white">
            Shopman
          </span>
        </NavLink>

        {/* Center: Nav links */}
        <div className="flex items-center gap-6">
          {navItems.map(({ to, icon: Icon, labelKey, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-1 py-4 text-sm font-medium transition ${
                  isActive ? activeLinkClass : inactiveLinkClass
                }`
              }
            >
              <Icon className="w-4 h-4" />
              <span>{t(labelKey)}</span>
            </NavLink>
          ))}
        </div>

        {/* Right: Controls */}
        <div className="flex items-center gap-2 shrink-0">
          <UserBadge />
          <ThemeToggle />
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
}
